import { action, observable, computed } from "mobx";
import type { RootStore } from "@state/stores/types";

class BasePopupStore {
	@observable public _isActive = false;
	protected timerId: ReturnType<typeof setTimeout> | undefined = undefined;

	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@computed get isActive() {
		return this._isActive;
	}
	@action.bound
	activatePopup() {
		this._isActive = true;
	}

	@action.bound
	deactivatePopup() {
		this._isActive = false;
	}

	clearTimer() {
		if (this.timerId != null) {
			clearTimeout(this.timerId);
			this.timerId = undefined;
		}
	}
}

export default BasePopupStore;
